"use client";

import { Button } from "@ui/components/core/Button";
import Spinner20 from "@ui/icons/20x20/spinner-20.svg";
import * as m from "motion/react-m";

import { useSTTTranslationCtx } from "../STTTranslations";

export function TranscribingView({
  title,
  description,
  cancel,
}: {
  cancel: () => void;
  description: string;
  title: string;
}) {
  const t = useSTTTranslationCtx();
  return (
    <div className='flex h-full flex-col items-center justify-center gap-8 bg-default'>
      <m.div
        animate={{ scale: 1, opacity: 1 }}
        className='relative'
        initial={{ scale: 0.8, opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <m.div
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.5, 0.2, 0.5],
          }}
          className='bg-primary/20 absolute inset-0 rounded-full'
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <Spinner20 className='animate-spin' />
      </m.div>
      <m.div
        animate={{ y: 0, opacity: 1 }}
        className='flex flex-col items-center gap-4'
        initial={{ y: 20, opacity: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <h3 className='f-ui-01'>{title}</h3>
        <p className='text-muted-foreground f-ui-02'>{description}</p>

        <Button className='mt-24' onClick={cancel} variant='secondary'>
          {t("widget.transcribing.cancel")}
        </Button>
      </m.div>
    </div>
  );
}
